import { RegistrationState } from "@faro-lotv/service-wires";
import { StatusResultCloudRegistration } from "@api/progress-api/progress-api-types";
import { PublishedData } from "@pages/data-management/published-data/published-data-types";
import { RegisteredData } from "@pages/data-management/registered-data/registered-data-types";

/**
 * @returns true if the data is currently being published.
 */
export function checkIsPublishing(): boolean {
  // Current approach just returns false since we don't know that yet.
  return false;
}

/**
 * @returns time when the most recent published revision was modified.
 *          If no revisions are published, returns 0.
 */
function timePublished(publishedRevisions: PublishedData[]): number {
  const publishedRevision = publishedRevisions.length ? publishedRevisions[0] : undefined;
  return publishedRevision ? new Date(publishedRevision.modifiedAt).getTime() : 0;
}

/**
 * @returns true if the data is published, and has no draft changes.
 *          Also checks that the time of publish is after upload and registration.
 */
export function checkIsPublished(
  publishedRevisions: PublishedData[],
  hasAnyDraftChanges: boolean,
  timeUpload: number,
  timeRegister: number
): boolean {
  const publishedRevision = publishedRevisions.length ? publishedRevisions[0] : undefined;
  const timePublish = timePublished(publishedRevisions);
  return !!publishedRevision && !hasAnyDraftChanges &&
    0 < timePublish && timeUpload <= timePublish && timeRegister <= timePublish;
}

/**
 * @returns true if the data is registered, but not published due to an error.
 */
export function hasPublishError(registeredData: RegisteredData): boolean {
  const statusResult = registeredData.task?.status?.result as StatusResultCloudRegistration | undefined;
  return (registeredData.state === RegistrationState.registered || registeredData.task?.state === "Succeeded") &&
    statusResult?.additionalData?.state === "FAILED" &&
    statusResult?.additionalData?.error === "PUBLISH_FAILED";
}
